<ion-button (click)="showAddMicroframeScoreboards = !showAddMicroframeScoreboards" expand="block" fill="clear" shape="round">
  @if (showAddMicroframeScoreboards) {
    Hide Add Scoreboards
  } @else {
    Add Scoreboards
  }
</ion-button>

@if (showAddMicroframeScoreboards) {
  <ion-list>  
    <ion-item lines="none">
      <ion-textarea label="Enter Microframe Sports Identifier" labelPlacement="floating" [(ngModel)]="token"></ion-textarea>
      <ion-button slot="end" (click)="saveToken()">
        Save
      </ion-button>
    </ion-item>
  </ion-list>
}
